module.exports = __webpack_public_path__ + "2142605417ba5bfb0eaafbd3309042d4.svg";